/* eslint-disable react/forbid-elements */
import React from 'react';
import { ToolTip } from '../../elements';
import { MarkdownEditor } from './MarkdownEditor';

type EditPanelMarkdownProps = {
    value?: string | undefined;
    name: string;
    handleChange: (value: string, name: string) => void;
    placeholder?: undefined | string;
    topLabel?: undefined | string;
    topLabelTooltip?: undefined | string;
    hasTableEditor?: undefined | boolean;
    size?: 'small' | 'medium' | 'large' | undefined;
};

export function EditPanelMarkdown(props: EditPanelMarkdownProps) {
    return (
        <>
            {props.topLabel && (
                <span className="ml5">
                    {props.topLabel}
                    {ToolTip({ text: props.topLabelTooltip })}
                </span>
            )}
            <MarkdownEditor
                value={props.value ?? ''}
                onChange={(value) => props.handleChange(value, props.name)}
                placeholder={props.placeholder}
                hasTableEditor={props.hasTableEditor}
                size={props.size}
            />
        </>
    );
}
